const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  lang: state => state.settings.lang,
  user: state => state.user.user,
  qtyObj: state => state.noticeQty.qtyObj,
  // avatar: state => state.user.avatar,
  // name: state => state.user.name,
  // introduction: state => state.user.introduction,
  // roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  choise_top_menu_path: state => state.permission.choise_top_menu_path,
  errorLogs: state => state.errorLog.logs

  // productTypes: state => state.type.types
}
export default getters
